export default __webpack_public_path__ + "static/media/girls.3bb852f9.webp";